<template>
  <div class="colors">
    <span
      v-for="color in colors"
      :key="color"
      class="color"
      :style="{ background: color }"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'AvailableColors',
  props: {
    colors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.colors {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  span {
    display: block;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    border: 1px solid transparent;
    box-shadow: 0 0 1px 1px color(grey, 25000);
    user-select: none;
  }
}
</style>
